export default __webpack_public_path__ + "static/media/team-line.57bebfe8.svg";